module.exports = __webpack_public_path__ + "static/media/grad-cap.f5c6dbcf.png";